import React from "react";

/**
 * Renders a Lucide icon with consistent stroke weight; use inside flex icon shells (value-icon, etc.).
 */
export default function IconBox({ icon: Icon, size = 24, strokeWidth = 1.75, className = "", ...rest }) {
  if (!Icon) return null;
  return <Icon className={className} size={size} strokeWidth={strokeWidth} aria-hidden {...rest} />;
}
